/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	companyInfo: state => {
		return state.companyInfo;
	},
	getPropertyCompanyInfo: state => key => {
		return state.companyInfo[key];
	}
};
